import { useState, useEffect } from "react";
import { useSocket } from "./useSocket";
import * as microsoftTeams from "@microsoft/teams-js";

export default function useTeamsSdk(joinUrl, meetingId) {
  const [coachingLogs, setCoachingLogs] = useState([]);
  const [metrics, setMetrics] = useState({
    score: "N/A",
    engagement: "N/A",
    sentiment: "N/A",
  });

  const { socketRef } = useSocket(setMetrics, meetingId, setCoachingLogs);

  useEffect(() => {
    async function configureSdk() {
      try {
        await microsoftTeams.app.initialize();
        console.log("✅ Teams SDK initialized");
        if (!socketRef) return;

        // Cleanup
        return () => {
          if (socketRef.current) {
            socketRef.current.off("sentimentUpdate");
            socketRef.current.off("coachingTip");
          }
        };
      } catch (error) {
        console.log("Teams SDK error:", error);
      }
    }
    configureSdk();
  }, [joinUrl, meetingId, socketRef]);

  return { metrics, coachingLogs };
}
